<template>
  <!-- 客户余额 -->
  <div class="memPriceList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['客户管理', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.start"
          style="width: 200px; margin-right: 10px"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.end"
          style="width: 200px; margin-right: 10px"
          placeholder="选择结束日期"
        >
        </el-date-picker>
        <el-select
          v-model="searchForm.status"
          placeholder="客户状态"
          style="width: 100px; margin-right: 5px"
        >
          <el-option
            v-for="(item, index) in itemList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
        ></el-input>
        <el-button type="primary" @click="seach" icon="el-icon-search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="AddTime"
        align="center"
        show-overflow-tooltip
        label="申请时间"
      >
      </el-table-column>
      <el-table-column
        prop="OrderNo"
        align="center"
        show-overflow-tooltip
        label="单据编号"
      >
      </el-table-column>
      <el-table-column
        prop="BusinessName"
        align="center"
        show-overflow-tooltip
        label="客户名称"
      >
      </el-table-column>
      <el-table-column
        prop="Amount"
        align="center"
        show-overflow-tooltip
        label="提现金额"
      >
      </el-table-column>
      <el-table-column
        prop="Remark"
        align="center"
        show-overflow-tooltip
        label="备注"
      >
      </el-table-column>
      <el-table-column
        prop="Status"
        align="center"
        show-overflow-tooltip
        label="状态"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.Status == 0">已拒绝 </el-tag>
          <el-tag v-if="scope.row.Status == 1">待审核 </el-tag>
          <el-tag v-if="scope.row.Status == 2">已通过 </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            style="padding: 2px 3px"
            v-if="scope.row.Status == 1"
            @click="AuditRemeark(scope.row, 2)"
            >通过</el-button
          >
          <el-button
            type="warning"
            plain
            style="padding: 2px 3px"
            v-if="scope.row.Status == 1"
            @click="AuditRemeark(scope.row, 0)"
            >拒绝</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "MemPriceList",
  data() {
    return {
      /**表格数据 */
      // {
      //   organCode:"机构编码",
      //   organName:"机构名称",
      //   name:"姓名",
      //   tel:"联系方式",
      //   province:"省",
      //   city:"市",
      //   area:"区",
      //   status:"状态"
      // }
      tableData: [],
      /**搜索表单 */
      searchForm: {
        name: "",
        status: "1",
        start: "",
        end: "",
      },
      itemList: [
        {
          value: "99",
          label: "全部",
        },
        {
          value: "0",
          label: "已拒审",
        },
        {
          value: "1",
          label: "未审核",
        },
        {
          value: "2",
          label: "已审核",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  components: {},
  mounted() {
    this.searchForm.start = this.$theMonthFirstDay(); // 默认查询本月的，查询太多了会卡
    this.searchForm.end = this.$theMonthFirstOnDay(); // 默认查询本月的，查询太多了会卡
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    // 搜索表格数据
    seach() {
      this.getTableData(1);
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        status: this.searchForm.status,
        valStr: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
        orderType: "CBW",
      };
      this.$request({
        method: "post",
        url: "/Management/MemberAdmin/GetUserBalanceOrderList",
        dataType: "json",
        data: data,
      })
        .then((res) => {
          this.tableData = [];
          if (res.success) {
            this.tableData = res.dataList;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 修改备注
    AuditRemeark(row, status) {
      this.$prompt("请输入备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          console.log(status, value, "2323");
          if (status == 0 && value == null) {
            this.$message({
              type: "warning",
              message: "审核不通过,备注不能为空",
            });
            return;
          }
          this.$request({
            method: "post",
            url: "/Management/MemberAdmin/AuditUserBalanceOrder",
            data: {
              orderNo: row.OrderNo,
              status: status,
              Remark: value,
            },
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "warning",
                  message: res.message,
                });
                this.getTableData();
              } else {
                this.$message({
                  type: "warning",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**点击审核按钮 */
    handleAudit(row) {
      this.$prompt("请输入备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          console.log(value, row, "23232");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
  },
};
</script>

<style scoped>
.memPriceList {
  width: 100%;
  height: 100%;
}
</style>
